module.exports = __webpack_public_path__ + "static/media/external-link.c7f69a6f.svg";